import {makeAutoObservable} from "mobx";
import {environment} from "../../../env";
import type {CategorizationReviewPageController} from "./CategorizationReviewPageController";
import type ProfileStore from "../../../stores/ProfileStore";
import type AuthStore from "../../../authentication/AuthStore";
import type {NavigateFunction} from "react-router";

export type Page = 'welcome'
    | 'demo-ai-run'
    | 'review-dashboard'
    | 'review'
    | 'ai-busy'

/**
 Accessible by: `categorizationReviewStore.reviewPageController.reviewPageStateController`
 */
export class CategorizationReviewPageStateController {

    page: Page;

    constructor(
        private categorizationReviewPageController: CategorizationReviewPageController,
        private profileStore: ProfileStore,
        private auth: AuthStore,
    ) {
        makeAutoObservable(this)
        this.page = environment.isTestReviewPage ? 'review' : (!this.profileStore.p.enableBuFilter ? 'review' : 'welcome')
    }

    setPage(page?: Page) {
        if (!page) {
            // Set default page
            page = !this.profileStore.p.enableBuFilter ? 'review' : 'welcome'
        }
        this.page = page;
    }

    get previousLabel(): string | null {
        switch (this.page) {
            case "demo-ai-run":
            case "review-dashboard":
                return 'Back'
        }
        if (this.profileStore.p.enableBuFilter && this.page === 'review') {
            return 'Back'
        }
        return null
    }

    onClickPrevious(navigate: NavigateFunction, backUrl: string) {
        switch (this.page) {
            case "welcome":
            case "demo-ai-run":
                navigate('' + backUrl);
                return
            case "review-dashboard":
            case "review":
                if (this.categorizationReviewPageController.isValidationBag) {
                    navigate('' + backUrl);
                    return
                }
                this.categorizationReviewPageController.navigateToPage('review')
                return;
        }
    }

    get nextLabel(): string | null {
        if (!this.profileStore.p.enableBuFilter) return null;
        switch (this.page) {
            case "review-dashboard":
                return 'Next'
            default:
                return null;
        }
    }

    onClickNext() {
        if (!this.profileStore.p.enableBuFilter) return null;
        switch (this.page) {
            case "welcome":
            case "demo-ai-run":
            case "review-dashboard":
                this.categorizationReviewPageController.navigateToPage('review')
                return
        }
    }
}